// extracted by mini-css-extract-plugin
module.exports = {"pagetitle":"about-module--pagetitle--21Z08"};